import * as XLSX from 'xlsx';

export function isXLSX(file) {
  return /\.(xlsx|xls|ods)$/i.test(file.name);
}

export async function xlsxToCSV(file) {
  const buffer = await file.arrayBuffer();
  const wb = XLSX.read(buffer, { type: 'array' });
  const ws = wb.Sheets[wb.SheetNames[0]];
  // Collapse embedded newlines in string cells so the CSV parser's line-split works correctly
  for (const key of Object.keys(ws)) {
    if (key[0] === '!') continue;
    const cell = ws[key];
    if (cell && cell.t === 's' && typeof cell.v === 'string') {
      cell.v = cell.v.replace(/[\r\n]+/g, ' ').trim();
      if (cell.w) cell.w = cell.v;
    }
  }
  return XLSX.utils.sheet_to_csv(ws);
}
